// extracted by mini-css-extract-plugin
export default {"button-loading":"IngestStructuredDocumentButton_button-loading__+f06m"};